// utils/dto-mappers/instant-feedback.mapper.ts

import {
  InstantFeedbackDTO,
  InstantFeedbackFullResponseDTO,
} from '../../dtos/instant-feedback.dto';
import { InstantFeedbackResponse } from '../../types/responses/instant-feedback.responses';
import { fileUploadItemResponseToFileDTO } from './files.translators';

export const InstantFeedbackDTOFromAPIResponse = (
  response: InstantFeedbackResponse
): InstantFeedbackDTO => {
  const parsedRequest = JSON.parse(
    response.full_request
  ) as InstantFeedbackFullResponseDTO;

  // Add line breaks to expectation
  if (parsedRequest.expectation) {
    parsedRequest.expectation = parsedRequest.expectation.replace(
      /\r?\n/g,
      '<br /><br />'
    );
  }

  // Clear submission if it's identical to the filename
  if (
    parsedRequest.filename &&
    parsedRequest.submission &&
    response.attachment &&
    parsedRequest.submission.trim() === parsedRequest.filename.trim()
  ) {
    parsedRequest.submission = '';
  }

  return {
    ...response,
    full_request: parsedRequest,
    attachment: response.attachment
      ? fileUploadItemResponseToFileDTO(response.attachment)
      : undefined,
  };
};
